import { render, staticRenderFns } from "./EmailSettingsFields.vue?vue&type=template&id=5ae1dfa8&lang=pug&"
import script from "./EmailSettingsFields.vue?vue&type=script&lang=js&"
export * from "./EmailSettingsFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports